var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoggles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_470_562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_470_562",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_470_562",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_470_562",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADIklEQVR4nO3bO2gUURTG8Y2JEiHGN2q0VQhWIqawEa2CCCKCaOej0EpBJLFS0cYiKlqFKClEQURBxEc6LaIoKr4hEJ9EwUqiaEgC5i8XDriEdTK7e3fm7s73g22yzN5zvtydncedXE5EREREREREREREREREREREMg9oBlYC7cBuoBM4CXQDV4A+4BEwALwHPgLf817j/DM+6b0Pts2AfUaffWa3jdFpY7ZbDc1V/Q8BmoA11lQXcAd4C/wkPD+AN1Zjl9Xsam/KhQSoB1YBB4DrNqsmqH4T9u24Zr25HuuTDrfFBr9tMyIrhoFbwH6XQaXCnQ/sA+4Df9LuOAAug3vAXpeNj4AXAscyNnOL9Qs4W9Ist6ODM8BI0cNm1whwCpgVN2T3q/sp7aqrmDskXT1VyG32VZDyuAzbooJ+QPpGgY5S9nl2ROROTMbSbsJlGVVoCAV2FBtwgT5c2GkbiyowBEs8BL2YAGQh6KUEIPSgOzwEfZgAhB70aI38GAYfdM1Q0AlR0AlR0AlR0AEEnX9PTip4Zhjifb1qNRwV9FDa1dWQz1FBP067uhryMCpod9dX/LgaFfRxT4MIHI0KepsS8mZrVNDL/I2TeS3/DdrCHsx8ROUbiAzZgj7nYaCsOx0n6HVpV1kD1sZduKh1HaVziyOnTRl0SLeCqtShWCHnLWrUdY/iuTWK82IHbWGfKGGgrDtSVMgW9Gzga9qVV5Gh2AscC4S9hTC8AvYAra4Ze7Xa314Ths0lhZwXdm/KDXQDDRH1TQd6Uq7xQlkhWyONwNOUGugpos7zKdXoLi03lh103sp/92RVku5GzeQCNTbYNklyu60FXkKetHDwSUINPCvlETTbd7ttk5rJi7yGnNfITOBihRt4WU4DNiEq/QPZ6213MUUzmyp0mn4DmOOhvrnAzQo9NrHRT4rxm5kB7AJeeGhgENgO1Hmsrw7YAbzzUN9zYKc7wvFVX6lNrQAOApftmPebrQot5DfwBeh3lxOB9bEvwpRW2zRgg43Vb2O7GgoZtdpdD5esp+WVqk1ERERERERERERERERERHJ+/QXaRWM8mTDnWAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoggles);
export default __webpack_public_path__ + "static/media/goggles.8188eeeccf793754100feb8186c0b542.svg";
export { ForwardRef as ReactComponent };